import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import { ElementType, NumberFormat, SelectCombos, CommonResponses, } from '../Enums/constants';

export const PabsUkAllMembersTab = () => {
    return (
        <SurveyPage pageName='All Members'>
            <SurveyTitleArea labelText='' />
            <SurveyContentContainer>
                <SurveySection labelText='Benefit Statements'>
                    <SurveyElement
                        questionNumber='36'
                        labelText='How do you distribute benefit statements to the majority of your members?'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.ONLINE_POST}
                        name='UKMultiMembersBenefitStatementHowDistribute'
                    />
                    <SurveyElement
                        questionNumber='37'
                        labelText='If you post benefit statements on-line, do you email members when their statement is updated on your website (or to remind them if the on-line benefit statement is constantly refreshed)?'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO_NA}
                        name='EmailStatementsYN'
                    />
                    <SurveyElement
                        questionNumber='38'
                        labelText="On average, how current is an active member's data in the statements that the member receives (in months)?"
                        note='For example, if statements with data current to December 31st are sent or made available in a staggered process beginning May 1st and finishing June 30th, then the members are receiving data that is between 4 and 6 months old, or 5 months old on average.'
                        name='Q_181'
                        inputType={ElementType.NUMBER}
                        placeholder='# months'
                        format={NumberFormat.DECIMAL1}
                    />
                    <SurveyElement
                        questionNumber='39'
                        labelText='Do your statements for active members include:'
                    />
                    <SurveyElement
                        questionNumber='39.a'
                        labelText='Total accumulated pensionable service?'
                        inputType={ElementType.RADIOBUTTON}
                        name='q_183a'
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='39.b'
                        labelText='Pensionable earnings?'
                        name='q_183b'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='39.c'
                        labelText='How the value of the accrued benefit compares with the annual allowance?'
                        name='StatementsAccruedBenefit'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                </SurveySection>

                <SurveySection labelText='Estimates'>
                    <SurveyElement
                        questionNumber='40'
                        labelText='Do you offer written estimate?'
                        name='Q_104YN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            Q_104YN: {
                                not: CommonResponses.NO.toLowerCase()
                            }
                        }}
                    >
                        <SurveyElement
                            questionNumber='40.a'
                            labelText='What was your average turnaround time for posting estimates (from request)?'
                            name='UKSLAEstimateActual'
                            inputType={ElementType.NUMBER}
                            allowUnknown
                            placeholder='# days, unknown'
                        />
                        <SurveyElement
                            questionNumber='41'
                            labelText='Do your written pension estimates (including cover letters, etc. sent with the estimate):'
                        />
                        <SurveyElement
                            questionNumber='41.a'
                            labelText='Show the benefits payable at different retirement ages (where requested by the member)?'
                            name='UKEstimatesAgePayable'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='41.b'
                            labelText='Show Pension Commencement Lump Sum options as well as the full, uncommuted pension?'
                            name='q_109d'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                    </SurveyConditionalSegment>
                </SurveySection>

                <SurveySection labelText='Newsletters'>
                    <p>
                        Exclude any annual funding summary, annual reports or other
                        announcements - newsletters that are sent as part of a pack of other
                        information, but are separate documents, can be included.
                    </p>
                    <SurveyElement
                        questionNumber='42'
                        labelText='How many times did you send hard copy newsletters or emails containing news (or with links to news articles) in the year to:'
                    />
                    <SurveyElement
                        questionNumber='42.a'
                        labelText='Active members?'
                        inputType={ElementType.NUMBER}
                        name='q_176a'
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='42.b'
                        labelText='Deferred members?'
                        inputType={ElementType.NUMBER}
                        name='q_176c'
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='42.c'
                        labelText='Pensioners?'
                        inputType={ElementType.NUMBER}
                        name='q_176b'
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='43'
                        labelText='Customisation:'
                    />
                    <SurveyElement
                        questionNumber='43.a'
                        labelText='Are newsletters or emails customised for different member types (e.g., active, deferred, pensioners)?'
                        name='UKNewslettersCustomized'
                        subQuestion
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber='43.b'
                        labelText='Are newsletters or emails customised for different sub-groups (e.g., women, young versus nearing retirement, married members, etc.)?'
                        name='NewslettersActiveGroups'
                        subQuestion
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber='44'
                        labelText='Open and click rates:'
                    />
                    <SurveyElement
                        questionNumber='44.a'
                        labelText='Do you measure open and click rates on outbound mass emails containing news?'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO_NA}
                        name='UKEmailsClickRatesMeasured'
                        subQuestion
                    />
                    <SurveyConditionalSegment
                        showIf={{
                          UKEmailsClickRatesMeasured: [CommonResponses.BLANK, CommonResponses.YES]
                          }}
                    >
                      <SurveyElement
                          questionNumber='44.b'
                          labelText='What was your average open rate for news emails?'
                          inputType={ElementType.NUMBER}
                          format={NumberFormat.PERCENTAGE_UK}
                          placeholder='% / Unknown / n/a'
                          name='UKEmailsOpenRate'
                          subQuestion
                          allowUnknown
                          allowNA
                      />
                      <SurveyElement
                          questionNumber='44.c'
                          labelText='What was your average click rate for news emails?'
                          inputType={ElementType.NUMBER}
                          format={NumberFormat.PERCENTAGE_UK}
                          placeholder='% / Unknown / n/a'
                          name='UKEmailsClickRate'
                          subQuestion
                          allowUnknown
                          allowNA
                      />
                    </SurveyConditionalSegment>
                    <p>
                        Please note that open and click rates may not be used in our
                        analysis this year, so please do not spend time accessing the data
                        if it is not readily available. It is useful management
                        information and we are interested at this stage simply to see if
                        schemes are measuring and how they compare. For example, if your
                        open rates are between 5 - 10%, then please put 7.5%.
                    </p>

                </SurveySection>

                <SurveySection labelText='Members needing extra help / vulnerable members'>
                    <SurveyElement
                        questionNumber='45'
                        labelText='Do you, with the agreement of the member, place flags on a member’s record to suggest a need for additional help?'
                        name='UKVulnerableFlagYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            UKVulnerableFlagYN: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            questionNumber='46'
                            labelText='Do you flag the following needs specifically (i.e., are there different flags for each reason for needing extra help):'
                        />
                        <SurveyElement
                            questionNumber='46.a'
                            labelText='Visual impairment?'
                            name='UKVulnerableFlagVisualYN'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='46.b'
                            labelText='Hearing impairment?'
                            name='UKVulnerableFlagHearingYN'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='46.c'
                            labelText='Reading or writing difficulties?'
                            name='UKVulnerableFlagCommYN'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber='46.d'
                            labelText='Speaking/reading English as a second language?'
                            name='UKVulnerableFlag2ndLangYN'
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                    </SurveyConditionalSegment>
                    <SurveyElement
                        questionNumber='47'
                        labelText='Will you accept help for members with hearing and speech difficulties over the phone from specialist agencies (e.g., Relay UK)?'
                        name='UKVulnerableSpecHelpYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber='48'
                        labelText='Do you produce the following printed materials in Braille and/or large or plain text (including digitally):'
                    />
                    <SurveyElement
                        questionNumber='48.a'
                        labelText='Members’ booklet'
                        name='UKVulnerablePrintedMemBookYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='48.b'
                        labelText='Benefit statement'
                        name='UKVulnerablePrintedBenStmtYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber='49'
                        labelText='Do you have individuals or a team that are designated and trained to deal with members that need more help?'
                        name='UKVulnerableDesignatedTeamYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                </SurveySection>


                <SurveySection labelText='Feedback'>
                    <SurveyElement
                        questionNumber='50'
                        labelText='Did you survey your members to understand how they feel about you / your service / the scheme in the year?'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                        name='satisfactionyn'
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            satisfactionyn: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            questionNumber='51'
                            labelText="Did you conduct 'single activity' surveying only targeted to members who experienced the service? (i.e., you asked members that had just retired how they felt about the service they received during the process of retiring)"
                            inputType={ElementType.RADIOBUTTON}
                            options={SelectCombos.YES_NO}
                            name='UKSatSurvSingleActivity'
                        />
                        <SurveyConditionalSegment
                            showIf={{
                                UKSatSurvSingleActivity: { not: CommonResponses.NO.toLowerCase() }
                            }}
                        >
                            <SurveyElement
                                questionNumber='52'
                                labelText='Which of the following activities did you survey on in the year?'
                            />
                            <SurveyElement
                                questionNumber='52.a'
                                labelText='Website?'
                                name='UKMSatSurvNPSWebsite'
                                inputType={ElementType.RADIOBUTTON}
                                options={SelectCombos.YES_NO}
                                subQuestion
                            />
                            <SurveyElement
                                questionNumber='52.b'
                                labelText='Telephone calls?'
                                name='SatSurvNPSCalls'
                                inputType={ElementType.RADIOBUTTON}
                                options={SelectCombos.YES_NO}
                                subQuestion
                            />
                            <SurveyElement
                                questionNumber='52.c'
                                labelText='Retirement from active?'
                                name='UKMSatSurvNPSRetireActive'
                                inputType={ElementType.RADIOBUTTON}
                                options={SelectCombos.YES_NO}
                                subQuestion
                            />
                            <SurveyElement
                                questionNumber='52.d'
                                labelText='Retirement from deferred?'
                                name='UKMSatSurvNPSRetireDeferred'
                                inputType={ElementType.RADIOBUTTON}
                                options={SelectCombos.YES_NO}
                                subQuestion
                            />
                            <SurveyElement
                                questionNumber='52.e'
                                labelText='Joiner/new entrant?'
                                name='SatSurvNPSNewJob'
                                inputType={ElementType.RADIOBUTTON}
                                options={SelectCombos.YES_NO}
                                subQuestion
                            />
                            <SurveyElement
                                labelText='You are encouraged (but not required) to submit your feedback scores for the activities listed in the VoC tab at the end of this survey.'
                            />
                        </SurveyConditionalSegment>
                    </SurveyConditionalSegment>
                </SurveySection>
                <SurveySection labelText='Complaints'>
                    <SurveyElement
                        questionNumber='53'
                        labelText='How many complaints did you record from members in the year?'
                        name='UKComplaintsMemberServiceVol'
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder='#, unknown'
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber='54'
                        labelText="Do you include any 'expression of dissatisfaction' as a complaint?"
                        name='UKComplaintsMemberServiceDissatificationYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyElement
                        questionNumber='55'
                        labelText='Do you measure and record complaints that relate to the members’ service experience specifically (as opposed to other types of complaint)?'
                        name='UKComplaintsMemberServiceExpYN'
                        inputType={ElementType.RADIOBUTTON}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            UKComplaintsMemberServiceExpYN: { not: CommonResponses.NO.toLowerCase() }
                        }}
                    >
                        <SurveyElement
                            questionNumber='55.a'
                            labelText='How many service related complaints did you receive in the year?'
                            name='UKComplaintsMemberServiceExpVol'
                            inputType={ElementType.NUMBER}
                            format={NumberFormat.INTEGER}
                            placeholder='#'
                            subQuestion
                        />
                    </SurveyConditionalSegment>
                    <SurveyElement
                        questionNumber='56'
                        labelText='What was the average end-to-end time taken to close a complaint during the year (in weeks)?'
                        name='UKComplaintsMemberServiceExpTime'
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder='#, unknown'
                        allowUnknown

                    />
                    <SurveyElement
                        questionNumber='57'
                        labelText='How many complaints (of any type) were made in the year under Stage 1 of your Internal Dispute Resolution Procedure (IDRP)?'
                        name='UKComplaintsMemberServiceIDRPVol'
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        placeholder='#, unknown'
                        allowUnknown
                    />

                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    )
}